import { useMode } from '@/hooks/useMode';
import { MouseGlow } from './MouseGlow';
import { RippleOnClick } from './RippleOnClick';
import { RippleWaves } from './RippleWaves';

/**
 * Compõe o "modo água" inteiro: canvas de ondas + listener de clique +
 * brilho da seta no cursor. Renderiza apenas quando `mode === 'water'`.
 */
export function RippleStack() {
  const { mode } = useMode();
  if (mode !== 'water') return null;
  return (
    <>
      <RippleWaves zIndex={20} />
      <RippleOnClick />
      <MouseGlow />
    </>
  );
}
